webpackJsonp([191319344601756],{

/***/ 461:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _qs = __webpack_require__(58);
	
	var _domFormSerializer = __webpack_require__(56);
	
	var _Image = __webpack_require__(11);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	__webpack_require__(386);
	
	var _DownloadForm = __webpack_require__(445);
	
	var _DownloadForm2 = _interopRequireDefault(_DownloadForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DownloadBanner = function (_React$Component) {
	  _inherits(DownloadBanner, _React$Component);
	
	  function DownloadBanner() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, DownloadBanner);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      fields: {
	        centre: 'East Malvern'
	      }
	    }, _this.handleChange = function (e) {
	      e.persist();
	      _this.setState(function (prevState) {
	        var _extends2;
	
	        return {
	          fields: _extends({}, prevState.fields, (_extends2 = {}, _extends2[e.target.name] = e.target.value, _extends2))
	        };
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  DownloadBanner.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        name = _props.name,
	        subject = _props.subject,
	        action = _props.action,
	        handbookDownload = _props.handbookDownload;
	
	
	    var centres = ['East Malvern', 'Mildura', 'Mildura Central'];
	
	    var fields = this.state.fields;
	    var centre = fields.centre;
	
	
	    var title = '';
	    var description = 'Download our Family Handbook for all you need to know about enroling your child at one of our centres.';
	
	    return _react2.default.createElement(
	      'section',
	      { className: 'download-banner' },
	      _react2.default.createElement(_Image2.default, { background: true, src: '/images/uploads/handbook.jpg', alt: 'image of handbook' }),
	      centres.map(function (centreItem, index) {
	        return _react2.default.createElement(_DownloadForm2.default, {
	          key: centreItem + 'Download' + index,
	          active: centre === centreItem,
	          formName: centreItem + ' Download Form',
	          fields: fields,
	          handleChange: _this2.handleChange,
	          title: title,
	          description: description,
	          handbookDownload: handbookDownload
	        });
	      })
	    );
	  };
	
	  return DownloadBanner;
	}(_react2.default.Component);
	
	exports.default = DownloadBanner;
	module.exports = exports['default'];

/***/ }),

/***/ 1191:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 955:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = exports.ContactPageTemplate = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PageHeader = __webpack_require__(15);
	
	var _PageHeader2 = _interopRequireDefault(_PageHeader);
	
	var _Content = __webpack_require__(6);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	var _BreakoutBox = __webpack_require__(444);
	
	var _BreakoutBox2 = _interopRequireDefault(_BreakoutBox);
	
	var _Button = __webpack_require__(26);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _DownloadBanner = __webpack_require__(461);
	
	var _DownloadBanner2 = _interopRequireDefault(_DownloadBanner);
	
	var _ExceedBanner = __webpack_require__(28);
	
	var _ExceedBanner2 = _interopRequireDefault(_ExceedBanner);
	
	__webpack_require__(1191);
	
	var _reactHelmet = __webpack_require__(9);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Export Template for use in CMS preview
	var ContactPageTemplate = exports.ContactPageTemplate = function ContactPageTemplate(_ref) {
	  var body = _ref.body,
	      title = _ref.title,
	      featuredImage = _ref.featuredImage,
	      _ref$centres = _ref.centres,
	      centres = _ref$centres === undefined ? [] : _ref$centres,
	      footerSettings = _ref.footerSettings,
	      meta = _ref.meta;
	  return _react2.default.createElement(
	    'main',
	    { className: 'Contact' },
	    _react2.default.createElement(_PageHeader2.default, { title: title, backgroundImage: featuredImage }),
	    _react2.default.createElement(
	      'div',
	      { className: 'section Contact--Section1' },
	      _react2.default.createElement(
	        'div',
	        { className: 'container content Contact--Section1--Container' },
	        _react2.default.createElement(_Content2.default, { source: body })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'container Contact--Centres' },
	        _react2.default.createElement(
	          _reactHelmet2.default,
	          { defaultTitle: meta && meta.title || title + ' | Great Start ELC' },
	          meta && _react2.default.createElement('meta', { name: 'description', content: meta.description }),
	          meta && _react2.default.createElement('link', { rel: 'canonical', href: meta.canonical }),
	          _react2.default.createElement('script', {
	            async: true,
	            defer: true,
	            src: 'https://maps.googleapis.com/maps/api/js?key=AIzaSyARcDElAI3_4wBfjMmPIU_pXmzOlKobLHE&callback=initMap'
	          })
	        ),
	        centres && centres.map(function (_ref2) {
	          var title = _ref2.title,
	              _ref2$centreDetails = _ref2.centreDetails,
	              centreDetails = _ref2$centreDetails === undefined ? {} : _ref2$centreDetails;
	
	
	          if (!centreDetails) return null;
	
	          return _react2.default.createElement(
	            _BreakoutBox2.default,
	            { title: title, key: title },
	            centreDetails.openingHours && _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(
	                'strong',
	                null,
	                'Open Hours'
	              ),
	              _react2.default.createElement('br', null),
	              centreDetails.openingHours
	            ),
	            centreDetails.location && _react2.default.createElement(
	              'div',
	              { className: 'location' },
	              _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  'Centre Location'
	                ),
	                _react2.default.createElement('br', null),
	                centreDetails.location
	              ),
	              centreDetails.mapIframe && _react2.default.createElement(_Content2.default, { className: 'map-container', src: centreDetails.mapIframe })
	            ),
	            (centreDetails.email || centreDetails.phone) && _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'strong',
	                null,
	                'Contact Info'
	              ),
	              _react2.default.createElement('br', null),
	              centreDetails.phone && _react2.default.createElement(
	                'p',
	                null,
	                'T: ',
	                centreDetails.phone
	              ),
	              centreDetails.email && _react2.default.createElement(
	                'p',
	                null,
	                'E: ',
	                centreDetails.email
	              )
	            ),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              _Button2.default,
	              { to: '/enrolments/enrolling-great-start-early-learing-centre/' },
	              'Enrol Now'
	            ),
	            _react2.default.createElement(
	              _Button2.default,
	              { to: '/enrolments/book/' },
	              'Book Tour'
	            )
	          );
	        })
	      ),
	      _react2.default.createElement(_DownloadBanner2.default, null),
	      _react2.default.createElement(
	        'div',
	        { className: 'section thin' },
	        _react2.default.createElement(
	          'div',
	          { className: 'container' },
	          _react2.default.createElement(_ExceedBanner2.default, { footerSettings: footerSettings })
	        )
	      )
	    )
	  );
	};
	
	var ContactPage = function ContactPage(_ref3) {
	  var data = _ref3.data;
	  var page = data.page,
	      footerSettings = data.footerSettings;
	
	  return _react2.default.createElement(ContactPageTemplate, _extends({
	    body: page.html
	  }, page.frontmatter, {
	    centres: data.centres.edges.map(function (edge) {
	      return _extends({}, edge.node, edge.node.frontmatter);
	    }),
	    footerSettings: footerSettings
	  }));
	};
	
	exports.default = ContactPage;
	
	// Query for DefaultPage data
	// Use GraphiQL interface (http://localhost:8000/___graphql)
	// ID is processed via gatsby-node.js
	
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-contact-page-js-654f6544f353b86b779b.js